import messages from '@/messages.json';

function flattenObject(ob, prefix = false, result = null) {
    result = result || {};

    if (prefix && typeof ob === 'object' && ob !== null && Object.keys(ob).length === 0) {
        result[prefix] = Array.isArray(ob) ? [] : {};

        return result;
    }

    prefix = prefix ? prefix + '.' : '';

    for (const i in ob) {
        if (Object.prototype.hasOwnProperty.call(ob, i)) {
            if (typeof ob[i] === 'object' && !ob[i].length && ob[i] !== null) {
                flattenObject(ob[i], prefix + i, result);
            } else {
                result[prefix + i] = ob[i];
            }
        }
    }

    return result;
}

let flatten = flattenObject(messages);

export default (key, values) => {
    if (key) {
        const k = $env.locale.current + '.js.' + key;
        let message = flatten[k];

        if (message && values) {
            for (const [key, value] of Object.entries(values)) {
                message = message.replaceAll(':' + key, value);
            }
        }

        return message ? message : key;
    }
}